import { Helmet } from 'react-helmet-async';

import { usePageMeta } from './hooks/usePageMeta';

export function PageMeta() {
	const {
		data: { title, canonicalUrl, description, image },
	} = usePageMeta();

	return (
		<Helmet>
			<link rel="canonical" href={canonicalUrl}></link>
			<title>{title}</title>
			<meta property="title" content={title} />
			<meta name="description" content={description} />
			<meta property="og:url" content={canonicalUrl} />
			<meta property="og:title" content={title} />
			<meta property="og:description" content={description} />
			<meta property="og:image" content={image} />
			<meta property="og:type" content="website" />
			{/* Only one hrefLang link since the URL does not change for other languages */}
			<link rel="alternate" hrefLang="en-US" href={canonicalUrl} />
		</Helmet>
	);
}
